import { render, staticRenderFns } from "./EstoqueHistorico.vue?vue&type=template&id=999bd30a&"
import script from "./EstoqueHistorico.vue?vue&type=script&lang=js&"
export * from "./EstoqueHistorico.vue?vue&type=script&lang=js&"
import style0 from "./EstoqueHistorico.vue?vue&type=style&index=0&id=999bd30a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports